/**
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CHECKBOX_DIRECTIVES } from "./checkbox/index";
var ClrFormsModule = (function () {
    function ClrFormsModule() {
    }
    return ClrFormsModule;
}());
export { ClrFormsModule };
ClrFormsModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule],
                declarations: [CHECKBOX_DIRECTIVES],
                exports: [CHECKBOX_DIRECTIVES]
            },] },
];
/** @nocollapse */
ClrFormsModule.ctorParameters = function () { return []; };
//# sourceMappingURL=forms.module.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/forms/forms.module.js
// module id = 55
// module chunks = 4